<template>
  <MaskComponent dialogType="discount" v-show="$bus.discountDialogShow">
    <div class="dialog-discount">
      <div class="dialog-discount-title">{{ $bus.transify['FESTA_CONGRATULATION'] ? $bus.transify['FESTA_CONGRATULATION'] : 'FESTA_CONGRATULATION' }}</div>
      <div class="dialog-discount-text" v-html="getDialogDiscountText"></div>
      <div class="dialog-discount-tip">*{{ $bus.transify['FESTA_COUPON_REDEEM_2'] }}</div>
      <div class="dialog-discount-button">
        <DialogButton :text="$bus.transify['FESTA_CANCEL']" @clickDialogButton="cancel" :disabled="true" />
        <DialogButton :text="$bus.transify['FESTA_CONFIRM']" @clickDialogButton="confirm" />
      </div>
    </div>
  </MaskComponent>
</template>

<script>
import MaskComponent from '@/components/base/mask'
import DialogButton from '@/components/business-base/dialog-button'
import { addGA } from '@/utils/assist'

export default {
  components: {
    MaskComponent,
    DialogButton
  },
  data () {
    return {
      discount: 0
    }
  },
  computed: {
    getDialogDiscountText () {
      const htmlString = `<span style="font-size: 1.2em;color: #FFBD1A">${this.discount}%</span>`
      return this.$bus.replaceText(this.$bus.transify['FESTA_COUPON_REDEEM_1'], htmlString)
    }
  },
  methods: {
    confirm () {
      addGA('get-big-discount', 'click')
      this.$bus.currentDiscount = this.discount
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      // 更新bigDiscount
      this.$bus.bigDiscount.splice(index, 1, this.$bus.currentDiscount)

      // 抽奖结束后关闭 mark
      this.$bus.ticketBgMarkFlag = false

      // 抽奖结束后关闭dialog
      this.$bus.discountDialogShow = false

      this.$bus[`inuse${this.$bus.shopType}`] = true

      this.$bus.dialogCharacterTextStatus = 'bigDiscount'
    },
    cancel () {
      addGA('cancel-big-discount', 'click')
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      this.$bus.currentDiscount = this.$bus.discount[index]
      this.$bus.discountDialogShow = false
    }
  },
  watch: {
    // 打开的时候要抽取折扣
    '$bus.discountDialogShow': {
      handler (current) {
        if (current) {
          const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
          this.$api.discount({
            shop: index
          }).then(res => {
            this.discount = res.data.discount
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-discount {
  text-align: center;
  color: #fff;

  .dialog-discount-title {
    font-family: $main-font-family;
    @include px2res(font-size, 60);
  }

  .dialog-discount-text {
    @include px2res(margin-top, 45);
    @include px2res(margin-bottom, 25);
    font-family: $main-font-family;
    @include px2res(font-size, 55);
  }

  .dialog-discount-tip {
    color: #EB0000;
    font-family: $main-font-family;
    @include px2res(font-size, 30);
  }

  .dialog-discount-button {
    @include flexac;
    justify-content: space-between;
    @include px2res(width, 641);
    @include px2res(margin, 49, 'auto', 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/discount/index.vue